import {isNotNilOrEmpty} from 'ramda-adjunct';

import {useListEmailCredentialsQuery} from '@dms/api/core';

export const useEmailConfig = () => {
  const {data: smtpCredentials, isLoading, isError} = useListEmailCredentialsQuery({});

  const isEnabled = isNotNilOrEmpty(smtpCredentials?.credentials);

  return {isEnabled, isLoading, isError};
};
